import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  collection: [],
  loading: false,
  addBtnLoading: false,
  collectionBtnLoading: false,
  deleteBtnLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COLLECTION:
      return updateObject(state, action.payload);
    case actionTypes.COLLECTION_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
